import {
  Box,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  TextField,
  Button,
  Grid,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DragandDrop from "./DragandDrop";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomPhoneInput from "./CustomPhoneInput";
import AxiosInstance from "../Config/AxiosInstance";
import { ApiList } from "../Config/ApiList";
import toast from "react-hot-toast";
import { imageURL } from "../Utils/constants";
import CenterCard from "./CenterCard";
import CustomTextField from "./CustomTextField";

const validationSchema = Yup.object().shape({
  fullName: Yup.string().required("Full Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string().required("Phone Number is required"),
  password: Yup.string()
    .required("Password is required")
    .matches(
      /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/,
      "Password must contains minimum 8 characters and includes at least one uppercase letter, one number, and one special character (e.g., @, $, !, %, , ?, &)."
    ),
  cPassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
  
});

const AddUserForm = ({ onClose, clubData, GetAllClubs, setCurrentStep, onSuccess }) => {
  return (
    <Box sx={{ width: "100%" }}>
      <DialogTitle>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "600",
              fontStyle: "italic",
              flex: 1,
              width: "auto",
            }}
          >
            ADD CLUB ADMIN
          </Typography>
          <Box sx={{ display: "flex", width: "auto", gap: 1, alignItems: "center" }}>
            <Box
              sx={{
                width: "60px",
                height: "60px",
                // background: "#00000020",
                borderRadius: "8px",
              }}
            >
              <CenterCard
                cover_img={clubData?.logo}
                sx={{
                  width: "60px",
                  height: "60px",
                  objectFit: "cover",
                  boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                  borderRadius: "12px",
                  transition: "box-shadow 0.2s ease-in-out",
                  "&:hover": {
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  },
                }}
                style={{ objectFit: "cover", borderRadius: "12px" }}
              />
            </Box>
            <Box>
              <Typography
                sx={{ color: "#000938", fontWeight: "600", fontSize: "18px" }}
              >
                {clubData?.club_name}
              </Typography>
              <Typography
                sx={{ color: "#00000099", fontWeight: "400", fontSize: "18px" }}
              >
                #{clubData?.club_code}
              </Typography>
            </Box>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Formik
          initialValues={{
            fullName: "",
            email: "",
            phone: "",
            countryCode: "",
            password: "",
            cPassword: "",
            logo: null,
          }}
          validationSchema={validationSchema}
          onSubmit={async (values, { resetForm }) => {
            try {
              const formData = new FormData();
              formData.append("full_name", values.fullName);
              formData.append("email", values.email);
              formData.append("phno", values.phone);
              formData.append("phno_cc", values.countryCode);
              formData.append("password", values.password);
              formData.append("profile_img", values.logo);
              formData.append("club_id", clubData?.id);
              formData.append("role", 1);
              formData.append("type", 1);

              const response = await AxiosInstance.post(
                ApiList?.ADD_USER,
                formData
              );
              if (response.data?.s === 1) {
                resetForm();
                toast?.success(response?.data?.m);

                // Call onSuccess if provided (for club details page)
                if (onSuccess) {
                  onSuccess(response);
                } else {
                  // Legacy behavior for other uses
                  onClose();
                  if (GetAllClubs) GetAllClubs();
                  if (setCurrentStep) setCurrentStep(1);
                }

                // const userFormData = new FormData();
                // userFormData.append("club_id", clubData?.club_id);
                // userFormData.append("user_id", response?.data?.r);
                // userFormData.append("role", 1);
                // userFormData.append("type", 1);

                // const res = await AxiosInstance?.post(
                //   ApiList?.ADD_USER_TO_CLUB,
                //   userFormData
                // );
                // if (res?.data?.s === 1) {
                //   onClose();
                //   GetAllClubs();
                // }
              } else {
                toast?.error(response?.data?.m);
              }
            } catch (error) {
              console.log(error);
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting, // Add this
          }) => (
            <Form onSubmit={handleSubmit}>
              <Grid container spacing={3} sx={{ mt: 1 }}>
                {/* Left Column */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={{ fontWeight: "500", ml: 0.5, mb: 0.5 }}>
                      Upload Profile
                    </Typography>
                    <DragandDrop
                      setImage={(files) => setFieldValue("logo", files[0])}
                      currentImages={values.logo ? [values.logo] : []}
                      sx={{ mb: 2 }}
                    />
                    <Typography
                      sx={{
                        ml: 0.5,
                        fontSize: "12px",
                        color: "#d32f2f",
                        mb: 2,
                      }}
                    >
                      {" "}
                      {touched.logo && errors.logo}
                    </Typography>
                    <Box>
                      <Typography sx={{ fontWeight: "500", ml: 0.5, mb: 0.5 }}>
                        Full Name
                      </Typography>
                      <TextField
                        fullWidth
                        name="fullName"
                        placeholder="Full Name"
                        value={values.fullName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        sx={{
                          mb: 0.5,
                          "& .MuiOutlinedInput-notchedOutline ": {
                            outline: "none",
                            border: "none",
                          },
                          borderRadius: "20px",
                          border: "none",
                          outline: "none",
                          background: "#f3f3f3",
                        }}
                      />
                      <Typography
                        sx={{
                          ml: 0.5,
                          fontSize: "12px",
                          color: "#d32f2f",
                          mb: 2,
                        }}
                      >
                        {" "}
                        {touched.fullName && errors.fullName}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography sx={{ fontWeight: "500", ml: 0.5, mb: 0.5 }}>
                        Email
                      </Typography>
                      <TextField
                        fullWidth
                        name="email"
                        placeholder="Email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        sx={{
                          mb: 0.5,

                          "& .MuiOutlinedInput-notchedOutline ": {
                            outline: "none",
                            border: "none",
                          },
                          borderRadius: "20px",
                          border: "none",
                          outline: "none",
                          background: "#f3f3f3",
                        }}
                      />
                      <Typography
                        sx={{
                          ml: 0.5,
                          fontSize: "12px",
                          color: "#d32f2f",
                          mb: 2,
                        }}
                      >
                        {" "}
                        {touched.email && errors.email}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                {/* Right Column */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Box>
                      <Box sx={{ width: "100%", mb: 2 }}>
                        <Typography
                          sx={{ fontWeight: "500", ml: 0.5, mb: 0.5 }}
                        >
                          Phone Number
                        </Typography>
                        <CustomPhoneInput
                          name="phone"
                          value={`${values.countryCode}${values.phone}`} // Combine codes for display
                          onChange={(name, { countryCode, phone }) => {
                            setFieldValue("countryCode", countryCode);
                            setFieldValue("phone", phone);
                          }}
                          onBlur={handleBlur}
                          error={touched.phone && Boolean(errors.phone)}
                          helperText={touched.phone && errors.phone}
                        />
                      </Box>
                      <Box>
                        <Typography
                          sx={{ fontWeight: "500", ml: 0.5, }}
                        >
                          Password
                        </Typography>
                        <CustomTextField
                          fullWidth
                          name="password"
                          placeholder="Password"
                          value={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="password"
                          sx={{
                            mb: 0.5,

                            "& .MuiOutlinedInput-notchedOutline ": {
                              outline: "none",
                              border: "none",
                            },
                            borderRadius: "20px",
                            border: "none",
                            outline: "none",
                            background: "#f3f3f3",
                          }}
                        />
                        <Typography
                          sx={{
                            ml: 0.5,
                            fontSize: "12px",
                            color: "#d32f2f",
                            mb: 2,
                          }}
                        >
                          {" "}
                          {touched.password && errors.password}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography
                          sx={{ fontWeight: "500", ml: 0.5 }}
                        >
                          Confirm Password
                        </Typography>
                        <CustomTextField
                          fullWidth
                          type="password"
                          name="cPassword"
                          placeholder="Confirm Password"
                          value={values.cPassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          sx={{
                            mb: 0.5,

                            "& .MuiOutlinedInput-notchedOutline ": {
                              outline: "none",
                              border: "none",
                            },
                            borderRadius: "20px",
                            border: "none",
                            outline: "none",
                            background: "#f3f3f3",
                          }}
                        />
                        <Typography
                          sx={{
                            ml: 0.5,
                            fontSize: "12px",
                            color: "#d32f2f",
                            mb: 2,
                          }}
                        >
                          {" "}
                          {touched.cPassword && errors.cPassword}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                {/* Buttons */}
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 2,
                      mt: 2,
                      flexWrap: "wrap",
                    }}
                  >
                    <Button
                      type="submit"
                      variant="contained"
                      disabled={isSubmitting}
                      sx={{
                        bgcolor: "#00D8A2",
                        color: "#000938",
                        borderRadius: "25px",
                        px: 4,
                        fontWeight: 600,
                        textTransform: "none",
                        "&:hover": { bgcolor: "#00b98e" },
                        "&:disabled": { bgcolor: "#cccccc" },
                      }}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Box>
  );
};

export default AddUserForm;
